import { ProcedureUnitTypeRule } from '../../models/unit-type-rules-config';
import { ProcedureMapEnum } from '@core/procedure-helpers/models/procedure-map.enum';

export const rulesForImplantPlanningDefaultSendToEmpty: ProcedureUnitTypeRule = {
	ProcedureMaps: [ProcedureMapEnum.ImplantPlanningDefaultNoSendTo],
	TeethRules: []
};
